import useMemberPayments from "../hooks/use-member-payments";
import MemberPaymentForm from "../features/member-payments/components/member-payment-form";
import { useState } from "react";
import { MemberPaymentRequest } from "../service/model/member-payment.model";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as memberpaymentSlice from "../features/member-payments/member-payment.slice";
import Loader from "../components/loader";
import MemberPaymentSummary from "../features/member-payments/components/member-payment-summary";
import MemberPaymentTable from "../features/member-payments/components/member-payment-table";

const MemberPaymentsBusinessView = () => {
    const dispatch = useAppDispatch();
    const [showMemberPaymentForm, setShowMemberPaymentForm] = useState(false);
    const isLoading = useAppSelector(memberpaymentSlice.selectIsLoading);

    const [memberpayments] = useMemberPayments();

    const handleSubmit = (data: MemberPaymentRequest) => {
        dispatch(memberpaymentSlice.createMemberPayment(data));
        setShowMemberPaymentForm(false);
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {memberpayments &&
                <>
                    <MemberPaymentSummary />
                    <MemberPaymentTable payments={memberpayments} />
                    {showMemberPaymentForm &&
                        <MemberPaymentForm payment={undefined} editable={true} onClose={() => setShowMemberPaymentForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default MemberPaymentsBusinessView;